// components/Hero.js (alternativa)
import React from 'react';

const Hero = () => {
    return (
        <section id="inicio" className="pt-24 pb-16 bg-gray-800 text-white relative">
            <div className="absolute inset-0 opacity-10 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-cyan via-transparent to-transparent"></div>
            <div className="container mx-auto px-6 text-center relative z-10 mt-4">
                <h1 className="text-5xl font-bold font-poppins mb-4">Iron Five</h1>
                <p className="text-2xl font-montserrat mb-6 border-b-2 border-cyan pb-2 inline-block">
                    Tecnología con propósito público
                </p>
                <p className="text-xl max-w-2xl mx-auto font-lato">
                    Soluciones de software para una gestión pública más ágil, eficiente y cercana.
                </p>
            </div>
        </section>
    );
};

export default Hero;
